module.exports = __webpack_public_path__ + "static/media/rahul.859bfda4.webp";